import React from 'react'

const FollowingTab = props => (
  <svg
    width={props.width ? props.width : '22'}
    height={props.height ? props.height : '22'}
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M14.7597 5.7789C14.7597 8.78658 12.1761 11.2248 8.9891 11.2248C5.8021 11.2248 3.21853 8.78658 3.21853 5.7789C3.21853 2.77122 5.8021 0.333008 8.9891 0.333008C12.1761 0.333008 14.7597 2.77122 14.7597 5.7789ZM11.8744 5.7789C11.8744 7.28274 10.5826 8.50184 8.9891 8.50184C7.3956 8.50184 6.10382 7.28274 6.10382 5.7789C6.10382 4.27506 7.3956 3.05595 8.9891 3.05595C10.5826 3.05595 11.8744 4.27506 11.8744 5.7789Z'
      fill={props ? props.color : '#FFFFFF'}
    />
    <path
      d='M16.1326 18.4817L20.2444 14.9997L21.6666 16.6234L16.1326 21.6663L12.2288 17.9849L13.8444 16.333L16.1326 18.4817Z'
      fill={props ? props.color : '#FFFFFF'}
    />
    <path
      d='M8.9891 12.5863C4.20861 12.5863 0.333252 16.2436 0.333252 20.7551H3.21853C3.21853 17.7474 5.8021 15.3092 8.9891 15.3092C9.87624 15.3092 10.7166 15.4981 11.4675 15.8357V12.926C10.6824 12.705 9.85042 12.5863 8.9891 12.5863Z'
      fill={props ? props.color : '#FFFFFF'}
    />
  </svg>
  // <svg width="16" height="19" viewBox="0 0 16 19" fill={props ? props.color : '#FFFFFF'}
  //      xmlns="http://www.w3.org/2000/svg">
  //     <path
  //         d="M8.66634 11.8767V13.6184C7.91211 13.3517 7.1049 13.2699 6.31251 13.3799C5.52012 13.4898 4.76567 13.7883 4.11253 14.2502C3.45939 14.7121 2.92663 15.3241 2.55898 16.0345C2.19132 16.745 1.99952 17.5334 1.99967 18.3334L0.333008 18.3325C0.332749 17.3149 0.565442 16.3108 1.01326 15.397C1.46107 14.4833 2.11212 13.6841 2.91652 13.0609C3.72092 12.4377 4.65732 12.0068 5.65397 11.8014C6.65062 11.596 7.68106 11.6215 8.66634 11.8759V11.8767ZM6.99967 10.8334C4.23717 10.8334 1.99967 8.59587 1.99967 5.83337C1.99967 3.07087 4.23717 0.833374 6.99967 0.833374C9.76217 0.833374 11.9997 3.07087 11.9997 5.83337C11.9997 8.59587 9.76217 10.8334 6.99967 10.8334ZM6.99967 9.16671C8.84134 9.16671 10.333 7.67504 10.333 5.83337C10.333 3.99171 8.84134 2.50004 6.99967 2.50004C5.15801 2.50004 3.66634 3.99171 3.66634 5.83337C3.66634 7.67504 5.15801 9.16671 6.99967 9.16671ZM11.8272 16.595L14.773 13.6492L15.9522 14.8275L11.8272 18.9525L8.88051 16.0059L10.0597 14.8275L11.8263 16.595H11.8272Z"
  //         />
  // </svg>
)

export default FollowingTab
